/**
 * @name Global Action
 * @memberof module:common/actions
 * @type {ReduxAction}
 * @return {Object} Global Actions
 */
import { DialogFlag } from 'common/types/allocation';
import {
  SET_DIALOG_FLAG,
  SET_FIELD_ATTRS,
  SHOW_ALLOCATION_DRAWER,
  SHOW_APPROACH_DIALOG,
  SHOW_CAPTABLE_DRAWER,
  SHOW_FIRM_DRAWER,
  SHOW_FIRM_STEPPER,
  SHOW_LOADING_PROGRESS,
} from './types';

/**
 * @function
 * @name showFirmDrawer
 * @description bolean control open and close drawer.
 * @param {BOOLEAN} openFirmDrawer  - reducer state
 * @return {OBJECT} Action context
 */
export const showFirmDrawer = (openFirmDrawer: boolean) => ({ type: SHOW_FIRM_DRAWER, openFirmDrawer });

/**
 * @function
 * @name showAllocationDrawer
 * @description bolean control open and close drawer.
 * @param {BOOLEAN} openFundDrawer  - reducer state
 * @return {OBJECT} Action context
 */

export const showAllocationDrawer = (openAllocationDrawer: boolean) => ({
  type: SHOW_ALLOCATION_DRAWER,
  openAllocationDrawer,
});
/**
 * @function
 * @name showCaptableDrawer
 * @description bolean control open and close drawer.
 * @param {BOOLEAN} openCaptableDrawer  - reducer state
 * @return {OBJECT} Action context
 */
export const showCaptableDrawer = (openCaptableDrawer: boolean) => ({
  type: SHOW_CAPTABLE_DRAWER,
  openCaptableDrawer,
});

/**
 * @function
 * @name showLoadingProgress
 * @description bolean control show or hide loading progress.
 * @param {BOOLEAN} isShowLoadingProgress  - reducer state
 * @return {OBJECT} Action context
 */
export const showLoadingProgress = (isShowLoadingProgress: boolean) => ({
  type: SHOW_LOADING_PROGRESS,
  isShowLoadingProgress,
});

export const showFirmStepper = (isFirmStepperVisible: boolean) => ({
  type: SHOW_FIRM_STEPPER,
  isFirmStepperVisible,
});

export const showApproachDialog = (openApproachDialog: boolean) => ({
  type: SHOW_APPROACH_DIALOG,
  openApproachDialog,
});

export const setDialogFlag = (dialogFlag: DialogFlag) => ({ type: SET_DIALOG_FLAG, dialogFlag });

export const setFieldAttrs = (fieldAttributes: unknown) => ({ type: SET_FIELD_ATTRS, fieldAttributes });
